
const digest = '403ba200babe2b9f9ac5e44729f8583d6789ebc24d6dfc00dbd968e40a8a716d';
const classes = {"wrapper":"_wrapper_191mp_1","border":"_border_191mp_4","content":"_content_191mp_13","header":"_header_191mp_18","openEntryName":"_openEntryName_191mp_25","info":"_info_191mp_36","controls":"_controls_191mp_39","cancelled":"_cancelled_191mp_49","cancelledTitle":"_cancelledTitle_191mp_53","cancelledTag":"_cancelledTag_191mp_57","unclosedTag":"_unclosedTag_191mp_62"};
const css = `._wrapper_191mp_1 {
  background: #fff;
}
._wrapper_191mp_1 ._border_191mp_4 {
  display: flex;
  flex-direction: row;
  border: 1px solid #eaedf3;
  border-top: 0;
}
._wrapper_191mp_1 ._border_191mp_4:first-of-type {
  border-top: 1px solid #eaedf3;
}
._wrapper_191mp_1 ._border_191mp_4 ._content_191mp_13 {
  flex: 1;
  display: flex;
  flex-direction: column;
}
._wrapper_191mp_1 ._border_191mp_4 ._content_191mp_13 ._header_191mp_18 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 12px;
  padding: 12px 0 0 0;
}
._wrapper_191mp_1 ._border_191mp_4 ._content_191mp_13 ._header_191mp_18 ._openEntryName_191mp_25 {
  font-size: 16px;
  font-weight: 500;
  gap: 15px;
  display: flex;
  align-items: center;
}
._wrapper_191mp_1 ._border_191mp_4 ._content_191mp_13 ._header_191mp_18 ._openEntryName_191mp_25 span {
  font-size: 12px;
  color: #ccc;
}
._wrapper_191mp_1 ._border_191mp_4 ._content_191mp_13 ._info_191mp_36 {
  margin: 0 12px;
}
._wrapper_191mp_1 ._border_191mp_4 ._controls_191mp_39 {
  padding: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-left: 1px solid #eaedf3;
  gap: 15px;
  flex-direction: column;
}

._cancelled_191mp_49 {
  color: #999999;
}

._cancelledTitle_191mp_53 {
  text-decoration: line-through;
}

._cancelledTag_191mp_57 {
  font-size: 60%;
  color: #000;
}

._unclosedTag_191mp_62 {
  font-size: 60%;
  color: #fd7e31;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  